import { Card, Tabs } from 'antd';
import { VFC } from 'react';
import { useIntl } from 'react-intl';
import { MeterListTable } from './Table';
import { MeterListMap } from './Map';
import { MeterListContent as messages } from '../messages';

export const MeterListContent: VFC = () => {
  const intl = useIntl();
  return (
    <Card bordered={false}>
      <Tabs
        items={[
          {
            label: intl.formatMessage(messages.table),
            key: 'table',
            children: <MeterListTable />,
          },
          {
            label: intl.formatMessage(messages.map),
            key: 'map',
            children: <MeterListMap />,
          },
        ]}
        type="card"
      />
    </Card>
  );
};
